"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ClayDropDownGroup = function ClayDropDownGroup(_ref) {
  var children = _ref.children,
      header = _ref.header;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, header && /*#__PURE__*/_react.default.createElement("li", {
    className: "dropdown-subheader",
    role: "presentation"
  }, header), children);
};

var _default = ClayDropDownGroup;
exports.default = _default;